// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table_primary-column-present__qNs\\+p {
  display: flex;
  justify-content: space-between;
}
.Table_primary-column-present__qNs\\+p .Table_primary-column__jnbqE {
  width: 60%;
  align-items: flex-start;
}
.Table_primary-column-present__qNs\\+p .Table_columns__SrM5D {
  width: 40%;
}

.Table_columns__SrM5D {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
}

.Table_check-divider__CzRE6 {
  margin: 0px -15px;
}`, "",{"version":3,"sources":["webpack://./src/components/common/Table/Table.module.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,8BAAA;AAFJ;AAII;EACI,UAAA;EACA,uBAAA;AAFR;AAKI;EACI,UAAA;AAHR;;AAQA;EACI,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,WAAA;AALJ;;AAQA;EACI,iBAAA;AALJ","sourcesContent":["@use \"styles/typography\";\n@use \"styles/colors\";\n\n.primary-column-present {\n    display: flex;\n    justify-content: space-between;\n\n    .primary-column {\n        width: 60%;\n        align-items: flex-start;\n    }\n\n    .columns {\n        width: 40%;\n    }\n\n}\n\n.columns {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    width: 100%\n}\n\n.check-divider {\n    margin: 0px -15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-column-present": `Table_primary-column-present__qNs+p`,
	"primary-column": `Table_primary-column__jnbqE`,
	"columns": `Table_columns__SrM5D`,
	"check-divider": `Table_check-divider__CzRE6`
};
export default ___CSS_LOADER_EXPORT___;
